export default "__VITE_ASSET__DeFp8HEt__"